import { render, staticRenderFns } from "./DoughnutChartInterestsShort.vue?vue&type=template&id=519386e8&scoped=true&"
import script from "./DoughnutChartInterestsShort.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartInterestsShort.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartInterestsShort.vue?vue&type=style&index=0&id=519386e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519386e8",
  null
  
)

export default component.exports